import { Component, OnInit, OnDestroy } from "@angular/core";
import { BsModalRef } from "ngx-bootstrap/modal";

import { blobToBase64 } from "src/app/shared/utils/text";
import {
  WAService,
  WAContentType,
} from "src/app/shared/components/send-to-wa/send-to-wa.service";

export interface ModalPDFViewerConfig {
  src: Blob | string;
  filename: string;
  title: string;
  modalClass?: string;
  waNumbers?: string[];
  waText?: string;
}

@Component({
  selector: "app-pdf-viewer",
  templateUrl: "./pdf-viewer.component.html",
  styleUrls: ["./pdf-viewer.component.css"],
  providers: [WAService],
})
export class PdfViewerComponent implements OnInit, OnDestroy {
  private config: ModalPDFViewerConfig;
  private resolve: any;
  private reject: any;

  public src: Blob | string;
  public showToolbar: boolean = false;

  // Flag to track if the viewer is initialized
  private viewerInitialized: boolean = false;

  constructor(private modal: BsModalRef, private waService: WAService) {}

  ngOnInit(): void {
    // Initialize any required resources
  }

  ngOnDestroy(): void {
    // Clean up resources when component is destroyed
    this.src = null;
    this.viewerInitialized = false;
  }

  setOption(resolve, reject, config: ModalPDFViewerConfig): void {
    this.config = config;
    this.resolve = resolve;
    this.reject = reject;

    // Reset initialization state when setting new options
    this.viewerInitialized = false;
    this.showToolbar = false;

    // Set the source after a small delay to ensure any previous instance is cleaned up
    setTimeout(() => {
      if (typeof config.src === 'string') {
        this.src = config.src;
      } else if (config.src instanceof Blob) {
        const url = URL.createObjectURL(config.src);
        this.src = url;
      } else {
        this.src = '';
      }
    }, 50);
  }

  onPageRendered(event): void {
    // Only set showToolbar to true if not already initialized
    if (!this.viewerInitialized) {
      this.showToolbar = true;
      this.viewerInitialized = true;
    }
  }

  hide(): void {
    // Clean up before hiding
    this.viewerInitialized = false;
    this.showToolbar = false;

    this.resolve();
    this.modal.hide();
  }

  sendToWA(): void {
    if (typeof this.config.src === "string") {
      return;
    }

    blobToBase64(this.config.src)
      .then((base64String) => {
        const base64 = base64String.split(",")[1];

        this.waService.sendToWA(this.config.waNumbers || [], WAContentType.MEDIA, {
          mimetype: "application/pdf",
          filename: this.config.filename,
          value: base64,
          text: this.config.waText
        });
      })
      .catch((error) => {
        console.error("Erro:", error);
      });
  }
}
